import {faChartPie, faEllipsis, faSackDollar, faSackXmark, faTractor} from "@fortawesome/free-solid-svg-icons";
import TabNav from "components/common/tabs/TabNav";
import TabNavLink from "components/common/tabs/TabNavLink";
import {AppRoutes, URI_PARAMETER_KEYS} from "config/router";
import {Outlet, useParams} from "react-router-dom";
import {Roles} from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";
import { faForkLift } from "utilities/icons/my-fa-icons";

const AgricultureOverviewPage = () => {
    const {[URI_PARAMETER_KEYS.TARGET_SEASON_ID]: targetSeasonId} = useParams<{ [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: string }>();
    const context = useAppContext();

    let uriParams: Record<string, any> | undefined = undefined;
    if(targetSeasonId) {
        uriParams = {
            [URI_PARAMETER_KEYS.TARGET_SEASON_ID]: targetSeasonId
        }
    }

    return (
        <div className="agriculture-page app-tabs">
            <TabNav alt={targetSeasonId ? true : false}>
                <TabNavLink
                    to={targetSeasonId ? AppRoutes.AGRICULTURE_SEASON_OVERVIEW : AppRoutes.AGRICULTURE_OVERVIEW}
                    params={uriParams}
                    text="pages.overview"
                    icon={faChartPie}
                />
                <TabNavLink
                    to={targetSeasonId ? AppRoutes.AGRICULTURE_SEASON_OVERVIEW_SALE : AppRoutes.AGRICULTURE_OVERVIEW_SALE}
                    params={uriParams}
                    text="pages.agriculture.sale.list"
                    icon={faSackDollar}
                    hidden={!context.userHasRole(Roles.AGRICULTURE_SALES_READ)}
                />
                <TabNavLink
                    to={targetSeasonId ? AppRoutes.AGRICULTURE_SEASON_OVERVIEW_WORK : AppRoutes.AGRICULTURE_OVERVIEW_WORK}
                    params={uriParams}
                    text="pages.agriculture.work.harvest.list"
                    icon={faForkLift}
                    iconViewBox="120 80 350 350"
                    hidden={!context.userHasRole(Roles.AGRICULTURE_WORK_READ)}
                />
                <TabNavLink
                    to={targetSeasonId ? AppRoutes.AGRICULTURE_SEASON_OVERVIEW_MAINTENANCE : AppRoutes.AGRICULTURE_OVERVIEW_MAINTENANCE}
                    params={uriParams}
                    text="pages.agriculture.work.maintenance.list"
                    icon={faTractor}
                    hidden={!context.userHasRole(Roles.AGRICULTURE_WORK_READ)}
                />
                <TabNavLink
                    to={AppRoutes.AGRICULTURE_OVERVIEW_OTHER}
                    text="pages.other"
                    icon={faEllipsis}
                    hidden={targetSeasonId ? true : false}
                />
            </TabNav>
            <Outlet/>
        </div>
    );
};

export default AgricultureOverviewPage;
